import React, { useState } from 'react';
import { Switch } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { selectEditFurnitureRows, selectEditUtilitiesRows, selectIsEditMod } from 'store/redux-store/placement-mods/selectors';
import { GridCellParams } from '@mui/x-data-grid';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { Controller, useFormContext } from 'react-hook-form';
import { furnitureModStyles } from '../FurnitureMod.styles';

interface GridCellProps {
  [key: string]: any;
}

interface IIncludeCellProps {
  gridIdentifier: string;
}

export const getExistingRow = (editRequests, cellParams, isUtility) => {
  if (isUtility) {
    return editRequests?.find(row => row.placementUtilityId === cellParams?.cellParams?.row?.placementUtilityId);
  }
  return editRequests?.find(row => row.placementFurnitureId === cellParams?.cellParams?.row?.placementFurnitureId);
};

export const getNewRow = (editRequests, RowId) => {
  return editRequests?.find(row => row.id === RowId);
};

export const IncludeCell =
  ({ ...props }: IIncludeCellProps) =>
  (cellParams: GridCellParams) => {
    return <Include cellParams={cellParams} gridIdentifier={props.gridIdentifier} />;
  };

const Include = React.memo(function Include(cellParams: GridCellProps) {
  const dispatch = useDispatch();
  const [isInclude, setIsInclude] = useState(cellParams?.cellParams?.row?.include);
  const furnitureEditRequests = useSelector(selectEditFurnitureRows);
  const utilityEditRequests = useSelector(selectEditUtilitiesRows);
  const isModEdit = useSelector(selectIsEditMod);
  const { control } = useFormContext();
  const RowId = cellParams?.cellParams?.id;
  const isUtility = cellParams.gridIdentifier === 'Utility';
  const { classes } = furnitureModStyles({ isExpanded: false });

  const onClickHandler = () => {
    let newRow = isUtility ? utilityEditRequests.slice(0) : furnitureEditRequests.slice(0);
    let EditRow = isUtility
      ? cellParams?.cellParams?.row?.placementUtilityId
        ? getExistingRow(utilityEditRequests, cellParams, isUtility)
        : getNewRow(utilityEditRequests, RowId)
      : cellParams?.cellParams?.row?.placementFurnitureId
      ? getExistingRow(furnitureEditRequests, cellParams, isUtility)
      : getNewRow(furnitureEditRequests, RowId);

    let updatedRow = { ...EditRow, include: !isInclude };
    let editDescriptionIndex = isUtility
      ? utilityEditRequests?.findIndex(
          cellParams?.cellParams?.row?.placementUtilityId
            ? row => row.placementUtilityId === updatedRow.placementUtilityId
            : row => row.id === RowId,
        )
      : furnitureEditRequests?.findIndex(
          cellParams?.cellParams?.row?.placementFurnitureId
            ? row => row.placementFurnitureId === updatedRow.placementFurnitureId
            : row => row.id === RowId,
        );
    newRow[editDescriptionIndex] = updatedRow;
    isUtility
      ? dispatch(placementModsAction.setEditUtilitiesRows(newRow))
      : dispatch(placementModsAction.setEditFurnitureRows(newRow));
    setIsInclude(!isInclude);
  };

  return (
    <>
      <Controller
        name={`${isUtility ? 'utilityRequests' : 'furnitureRequests'}${RowId}.include`}
        control={control}
        render={({ field: { onChange, onBlur, value, ...rest } }) => (
          <>
            <Switch 
              checked={isInclude} 
              className={isModEdit ? classes.switchPrimary : classes.switchLightBlue} 
              onClick={() => {
                onClickHandler();
                onChange(!isInclude);
              }} 
              onBlur={onBlur} 
            />{' '}
            {isInclude ? 'Yes' : 'No'}
          </>
        )}
      />
    </>
  );
});
